// extracted by mini-css-extract-plugin
export var wrapper = "Taste-module--wrapper--o3S9S";